export default __webpack_public_path__ + "media/images/brighteon-social/intro_2-aaa4c152f9e42c997a047283ff68e45a.png";